var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4648",
    "data-name": "Raggruppa 4648",
    transform: "translate(-71 -232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4647",
    "data-name": "Raggruppa 4647",
    transform: "translate(47 42)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2109",
    "data-name": "Rettangolo 2109",
    width: 24,
    height: 24,
    transform: "translate(24 190)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_273",
    "data-name": "Raggruppa 273",
    transform: "translate(38.858 -55.643)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-sort-alpha-down",
    "data-name": "Icon awesome-sort-alpha-down",
    d: "M6.959,14.9h-1.9V2.883a.633.633,0,0,0-.633-.633H3.163a.633.633,0,0,0-.633.633V14.9H.633a.633.633,0,0,0-.446,1.08l3.163,3.8a.633.633,0,0,0,.894,0l3.163-3.8A.634.634,0,0,0,6.959,14.9Zm9.489-2.53H11.387a.633.633,0,0,0-.633.633V14.27a.633.633,0,0,0,.633.633H13.6l-2.422,2.785a1.265,1.265,0,0,0-.425.946v.7a.633.633,0,0,0,.633.633h5.061a.633.633,0,0,0,.633-.633V18.065a.633.633,0,0,0-.633-.633H14.234l2.422-2.785a1.265,1.265,0,0,0,.425-.946V13A.633.633,0,0,0,16.448,12.372ZM17.676,9,15.333,2.67a.633.633,0,0,0-.6-.42H13.1a.633.633,0,0,0-.6.42L10.159,9a.633.633,0,0,0,.6.845h.982a.633.633,0,0,0,.6-.438l.175-.511h2.807l.174.511a.633.633,0,0,0,.6.438h.982a.633.633,0,0,0,.6-.845ZM13.27,6.678l.648-1.9.648,1.9Z",
    transform: "translate(35.142 288.393)",
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.e00f600bfc6bc14c817b93eccbb61f90.svg";
export { ForwardRef as ReactComponent };